import Common from "./Common"

const Auth = {
    isLogin: () => {
        const { cUser, cToken } = Common.localStorageGetToken();
        if (!cUser || !cToken) return false;
        return true;
    }
}

export default Auth
